<template>
  <withTopNav :leftText="$t('Profile.leftText')" >
    <div class="text-15 py-2 px-4">
      <div class="cellGroup">
        <van-cell-group inset :title="$t('Profile.BasicSettings')">
          <van-cell :title="$t('Profile.Profile')" class="flex-center-y">
            <template #extra>
              <img :src="'/static/images/avatar' + userInfo.avatarUrl" class="size-15" />
            </template>
          </van-cell>
          <van-cell :title="$t('Profile.Surname')" :value="userInfo.nickname" is-link @click="showEditor(editApelido)" />
          <van-cell :title="$t('Profile.RegisteredAccount')" :value="userInfo.phoneNumber" />
          <van-cell :title="$t('Profile.Id')" :value="userInfo.userid" />
        </van-cell-group>
      </div>

      <div class="cellGroup mt-1">
        <van-cell-group inset :title="$t('Profile.SecuritySettings')">
          <van-cell :title="$t('Profile.Phone')" :value="userInfo.phoneNumber">
            <template #right-icon>
              <img src="@a/assets/images/i_dun.png" class="size-6" />
            </template>
          </van-cell>
          <van-cell :title="$t('Profile.Password')" value="********" is-link @click="showEditor(editSenha)" />
          <van-cell :title="$t('Profile.WithdrawalPassword')" v-if="hasWithdrawalPassword" :value="$t('Profile.AlreadySet')" />
          <van-cell :title="$t('Profile.WithdrawalPassword')" v-else :value="$t('Profile.NotConfigured')" is-link @click="handleSaqueClick($router)" />
        </van-cell-group>
      </div>

      <!-- <div class="cellGroup mt-1">
        <van-cell-group inset title="Vinculação de Conta de Terceiros">
          <van-cell title="Google:" value="sjdfj@gmail.com" />
          <van-cell title="Facebook:" value="facebook1212" />
          <van-cell title="YouTube:" value="Não Vinculado" is-link @click="showEditor(editVerificado)" />
        </van-cell-group>
      </div> -->
    </div>
  </withTopNav>
</template>

<script setup lang="ts">
  import withTopNav from '@/layouts/withTopNav.vue'
  import editApelido from './editApelido.vue'
  // import editVerificado from './editVerificado.vue'
  import editSenha from './editSenha.vue'
  import showPopup from '@a/components/showPopup'
  import closeIcon from '@a/assets/images/i_close_2.png'
  import { useUserInfo } from '@/store'
  import { handleSaqueClick } from "@/utils/userStatusUtils";
  import { checkWithdrawalPassword } from '@/api/saque'

  const userInfo = computed(() => useUserInfo().userInfo!);

  const showEditor = (content: any) => {
    showPopup(
      content, {
      round: true,
      closeable: true,
      closeIcon,
      position: 'bottom',
      class: 'bg-[var(--theme-text-dark)] [&>.van-icon]:!absolute [&>.van-icon_img]:!size-6',
      style: { height: '75%' }
    })
  }

  const hasWithdrawalPassword = ref(false);

  showLoadingToast('loading...');
  checkWithdrawalPassword({ value: '' })
    .then(res => {
      if (res.data) hasWithdrawalPassword.value = true;
      if (res.code === -3700) hasWithdrawalPassword.value = false;
    })
    .catch(e => {
      console.error(e)
    })
    .finally(() => {
      closeToast()
    })
</script>

<style lang="scss">
.cellGroup{
  .van-cell-group__title--inset{
    padding: 12px 0;
    color: white;
    display: flex;
    font-size: 15px;


    &:before{
      content: '';
      display: block;
      width: 3px;
      height: 15px;
      background-color: white;
      border-radius: 4px;
      margin-right: 8px;
    }
  }

  .van-icon-arrow:before{
    color: white;
  }

  .van-cell-group{
    background-color: transparent !important;
  }

  .van-cell-group--inset{
    margin: 0 0 0;
  }

  .van-cell{
    color: white;
    font-size: 15px;

    &:nth-child(odd){
      background-color: var(--theme-gray-green40);
    }

    &:nth-child(even){
      background-color: var(--theme-gray-green20);
    }

    &:after{
      border-bottom: 3px solid #151A1F;
      left: 0; right: 0;
      bottom: -1px
    }
  }

  .van-cell__value{
    color: rgba(255, 255, 255, 0.75);
  }
}
</style>
